/* LBD theme script. Vanilla, deferred, no dependencies. */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfg = window.LBD || {};
  var routes = cfg.routes || {};

  function money(cents) {
    var v = cents / 100;
    var s = Number.isInteger(v) ? String(v) : v.toFixed(2).replace(/\.?0+$/, '');
    return s + ' JD';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Shopify CDN image URL at width w; replaces any width/height/crop already present.
  function imgSize(url, w) {
    if (!url) return '';
    var parts = url.split('?');
    var query = (parts[1] || '').split('&').filter(function (p) { return p && !/^(width|height|crop)=/.test(p); });
    query.push('width=' + w);
    return parts[0] + '?' + query.join('&');
  }
  function imgSrcset(url, widths) {
    return widths.map(function (w) { return imgSize(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  /* ---------- One reveal on page load ---------- */
  window.requestAnimationFrame(function () {
    $$('.lbd-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });

  /* ---------- Layers: menu panel, search, cart drawer ---------- */
  var scrim = $('#LbdScrim');
  var openLayer = null;
  var lastFocus = null;

  function open(id) {
    var el = $(id);
    if (!el) return;
    if (openLayer && openLayer !== el) close();
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    openLayer = el;
    var focusTarget = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 60);
    if (id === '#LbdCart') refreshCart();
  }
  function close() {
    if (!openLayer) return;
    openLayer.classList.remove('is-open');
    openLayer.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    openLayer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) { e.preventDefault(); open(o.getAttribute('data-open')); return; }
    if (e.target.closest('[data-close]') || e.target === scrim) { e.preventDefault(); close(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(); closeViewer(); }
  });

  /* ---------- Predictive search ---------- */
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  var searchTimer;
  var searchReq;
  if (searchInput && searchResults) {
    searchInput.addEventListener('input', function () {
      window.clearTimeout(searchTimer);
      var q = searchInput.value.trim();
      if (q.length < 2) {
        if (searchReq) searchReq.abort();
        searchResults.innerHTML = '';
        return;
      }
      searchTimer = window.setTimeout(function () { suggest(q); }, 220);
    });
    // Arrow keys move between the input and the suggestions.
    searchInput.form.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var opts = $$('[data-search-option]', searchResults);
      if (!opts.length) return;
      var i = opts.indexOf(document.activeElement);
      e.preventDefault();
      if (e.key === 'ArrowDown') (opts[i + 1] || opts[0]).focus();
      else if (i <= 0) searchInput.focus();
      else opts[i - 1].focus();
    });
    searchResults.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;
      var opts = $$('[data-search-option]', searchResults);
      var i = opts.indexOf(document.activeElement);
      if (i < 0) return;
      e.preventDefault();
      if (e.key === 'ArrowDown') (opts[i + 1] || opts[i]).focus();
      else if (i === 0) searchInput.focus();
      else opts[i - 1].focus();
    });
  }
  function suggest(q) {
    // Rendered by sections/lbd-search-suggest.liquid so the drop-down applies
    // the same literal match as the search page.
    if (searchReq) searchReq.abort();
    searchReq = window.AbortController ? new AbortController() : null;
    var url = (routes.search_url || '/search') + '?q=' + encodeURIComponent(q) +
      '&type=product,page&options[prefix]=last&options[unavailable_products]=last&section_id=lbd-search-suggest';
    searchResults.setAttribute('aria-busy', 'true');
    fetch(url, searchReq ? { signal: searchReq.signal } : {})
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        if (searchInput.value.trim() !== q) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var root = doc.querySelector('.shopify-section') || doc.body;
        searchResults.innerHTML = root.innerHTML;
        searchResults.removeAttribute('aria-busy');
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        searchResults.innerHTML = '';
        searchResults.removeAttribute('aria-busy');
      });
  }

  /* ---------- Cart (AJAX API) ---------- */
  var cartItems = $('[data-cart-items]');
  var cartBusy = false;

  function setCounts(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.setAttribute('data-count', count); });
    $$('[data-cart-line]').forEach(function (el) {
      el.textContent = count + ' ' + (count === 1 ? cfg.strings.piece : cfg.strings.pieces) + ' ' + cfg.strings.held;
    });
  }
  function renderCart(cart) {
    setCounts(cart.item_count);
    var total = $('[data-cart-total]');
    if (total) total.textContent = money(cart.total_price);
    var checkout = $('[data-cart-checkout]');
    if (checkout) { if (cart.item_count === 0) checkout.setAttribute('aria-disabled', 'true'); else checkout.removeAttribute('aria-disabled'); }
    if (!cartItems) return;
    if (!cart.items.length) {
      cartItems.innerHTML = '<p class="lbd-drawer__empty">' + esc(cfg.strings.empty) + '</p>';
      return;
    }
    cartItems.innerHTML = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="lbd-line__meta">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="lbd-line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(imgSize(it.image, 180)) + '" alt="" width="72" height="90" loading="lazy">' : '') + '</a>' +
        '<div><a class="lbd-line__name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="lbd-line__row"><div class="lbd-qty">' +
        '<button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="' + esc(cfg.strings.less) + '">&minus;</button>' +
        '<span>' + it.quantity + '</span>' +
        '<button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="' + esc(cfg.strings.more) + '">+</button></div>' +
        '<span>' + money(it.final_line_price) + '</span>' +
        '<button type="button" class="lbd-line__remove" data-qty="0" aria-label="' + esc(cfg.strings.remove) + '">&times;</button>' +
        '</div></div></div>';
    }).join('');
  }
  var cartMsgTimer;
  function cartMessage(text) {
    $$('[data-cart-msg]').forEach(function (el) { el.textContent = text; });
    window.clearTimeout(cartMsgTimer);
    cartMsgTimer = window.setTimeout(function () {
      $$('[data-cart-msg]').forEach(function (el) { el.textContent = ''; });
    }, 5000);
  }
  function refreshCart() {
    return fetch((routes.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }
  function changeLine(key, qty) {
    if (cartBusy) return;
    cartBusy = true;
    fetch((routes.cart_change_url || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json().then(function (body) { return { ok: r.ok, body: body }; }); })
      .then(function (res) {
        if (!res.ok || !res.body || !res.body.items) {
          cartMessage((res.body && (res.body.description || res.body.message)) || cfg.strings.error);
          return refreshCart();
        }
        renderCart(res.body);
        if ($('[data-cart-page]')) window.location.reload();
      })
      .catch(function () { cartMessage(cfg.strings.error); refreshCart(); })
      .then(function () { cartBusy = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var line = b.closest('[data-key]');
    if (!line) return;
    changeLine(line.getAttribute('data-key'), parseInt(b.getAttribute('data-qty'), 10));
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-lbd-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-disabled', 'true');
    var fd = new FormData(form);
    fetch((routes.cart_add_url || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.status >= 400) {
          open('#LbdCart');
          cartMessage(res.description || res.message || cfg.strings.error);
          return;
        }
        open('#LbdCart');
      })
      .catch(function () { open('#LbdCart'); cartMessage(cfg.strings.error); })
      .then(function () { if (btn) btn.removeAttribute('aria-disabled'); });
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'lbd_wishlist';
  function getWish() {
    try { var v = JSON.parse(window.localStorage.getItem(WKEY) || '[]'); return Array.isArray(v) ? v : []; } catch (e) { return []; }
  }
  function setWish(list) {
    try { window.localStorage.setItem(WKEY, JSON.stringify(list)); } catch (e) { /* private mode */ }
    paintWish();
  }
  function paintWish() {
    var list = getWish();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) !== -1;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    $$('[data-wish-count]').forEach(function (el) { el.textContent = list.length; el.setAttribute('data-count', list.length); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish');
    var list = getWish();
    var i = list.indexOf(h);
    if (i === -1) list.push(h); else list.splice(i, 1);
    setWish(list);
    if (i !== -1 && b.hasAttribute('data-wish-remove')) {
      var card = b.closest('[data-wish-card]');
      if (card) card.remove();
      var page = $('[data-wishlist-page]');
      if (page && !page.querySelector('[data-wish-card]')) renderWishlist();
    }
  });
  paintWish();

  function renderWishlist() {
    var page = $('[data-wishlist-page]');
    if (!page) return;
    var list = getWish();
    if (!list.length) {
      page.innerHTML = '<div class="lbd-wish__empty"><p>' + esc(cfg.strings.wishEmpty) + '</p><p>' + esc(cfg.strings.wishHint) +
        ' <a class="lbd-link" href="' + esc(cfg.shopUrl) + '">' + esc(cfg.strings.seePieces) + '</a></p></div>';
      return;
    }
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var kept = [];
      var html = products.map(function (p, i) {
        if (!p) return '';
        kept.push(list[i]);
        var img = p.featured_image ? imgSize(p.featured_image, 720) : '';
        var sold = !p.available;
        return '<div class="lbd-card' + (sold ? ' lbd-card--sold' : '') + '" data-wish-card>' +
          '<a class="lbd-card__media" href="/products/' + esc(p.handle) + '">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(p.title) + '" width="720" height="900" loading="lazy">' : '') +
          (sold ? '<div class="lbd-card__badges"><span class="lbd-badge lbd-badge--out">' + esc(cfg.strings.out) + '</span></div>' : '') + '</a>' +
          '<div class="lbd-card__body"><a class="lbd-card__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
          '<div class="lbd-card__price">' + money(p.price) + '</div>' +
          (sold ? '<a class="lbd-card__again lbd-made-again" href="' + esc(cfg.contactUrl) + '?piece=' + encodeURIComponent(p.handle) + '&subject=made-again">' + esc(cfg.strings.madeAgain) + '</a>' : '') +
          '<div class="lbd-wish__remove"><button type="button" class="lbd-btn lbd-btn--secondary" data-wish="' + esc(p.handle) + '" data-wish-remove>' + esc(cfg.strings.takeOff) + '</button></div>' +
          '</div></div>';
      }).join('');
      if (kept.length !== list.length) { try { window.localStorage.setItem(WKEY, JSON.stringify(kept)); } catch (e) {} }
      if (!kept.length) { renderWishlist(); return; }
      page.innerHTML = '<div class="lbd-grid lbd-grid--4">' + html + '</div>';
      paintWish();
    });
  }
  renderWishlist();

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach(function (hero) {
    var slides = $$('.lbd-hero__slide', hero);
    if (!slides.length) return;
    var dots = $$('.lbd-hero__dot', hero);
    var counter = $('[data-hero-counter]', hero);
    var piece = $('[data-hero-piece]', hero);
    var ms = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
    var i = 0, timer = null, startedAt = 0, remaining = ms, paused = false;
    hero.style.setProperty('--lbd-hero-ms', ms + 'ms');

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) {
        d.classList.toggle('is-active', k === i);
        d.classList.toggle('is-done', k < i);
        if (k === i) { d.style.animation = 'none'; void d.offsetWidth; d.style.animation = ''; }
      });
      if (counter) counter.textContent = String(i + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      if (piece) {
        var s = slides[i];
        piece.innerHTML = '<a class="lbd-hero__piece" href="' + esc(s.getAttribute('data-url')) + '">' + esc(s.getAttribute('data-name')) +
          (s.getAttribute('data-sold') === 'true' ? ' &middot; ' + esc(cfg.strings.out) : '') + '</a>';
      }
      remaining = ms;
      schedule();
    }
    function schedule() {
      window.clearTimeout(timer);
      if (slides.length < 2 || reduced || paused) return;
      startedAt = Date.now();
      timer = window.setTimeout(function () { show(i + 1); }, remaining);
    }
    function pause() {
      if (paused) return;
      paused = true;
      hero.classList.add('is-paused');
      window.clearTimeout(timer);
      remaining = Math.max(200, remaining - (Date.now() - startedAt));
    }
    function resume() {
      if (!paused) return;
      paused = false;
      hero.classList.remove('is-paused');
      schedule();
    }
    hero.addEventListener('mouseenter', pause);
    hero.addEventListener('mouseleave', resume);
    hero.addEventListener('click', function (e) {
      var go = e.target.closest('[data-hero-go]');
      if (go) show(parseInt(go.getAttribute('data-hero-go'), 10));
      if (e.target.closest('[data-hero-prev]')) show(i - 1);
      if (e.target.closest('[data-hero-next]')) show(i + 1);
    });
    var visible = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.3 }).observe(hero);
    }
    document.addEventListener('keydown', function (e) {
      if (!visible || openLayer) return;
      var t = e.target.tagName;
      if (t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT') return;
      if (e.key === 'ArrowLeft') show(i - 1);
      if (e.key === 'ArrowRight') show(i + 1);
    });
    var tx = null;
    hero.addEventListener('touchstart', function (e) { tx = e.changedTouches[0].clientX; }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (tx === null) return;
      var dx = e.changedTouches[0].clientX - tx;
      tx = null;
      if (Math.abs(dx) > 40) show(dx < 0 ? i + 1 : i - 1);
    }, { passive: true });
    show(0);

    if (!reduced) {
      var tick = function () {
        var h = hero.offsetHeight || 1;
        var p = Math.min(1, Math.max(0, window.scrollY / h));
        hero.style.setProperty('--hero-scroll', p.toFixed(4));
        hero.style.setProperty('--hero-content', Math.max(0, 1 - p * 1.6).toFixed(3));
      };
      window.addEventListener('scroll', function () { window.requestAnimationFrame(tick); }, { passive: true });
      tick();
    }
  });

  /* ---------- Fixed-background simulation + text that rises in and fades out ---------- */
  var fixed = $$('[data-fixed]');
  var lifts = $$('[data-lift]');
  if ((fixed.length || lifts.length) && !reduced) {
    var scrollTick = function () {
      var vh = window.innerHeight;
      fixed.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < -vh || r.top > vh * 2) return;
        el.style.setProperty('--fix', (-r.top).toFixed(1) + 'px');
      });
      lifts.forEach(function (el) {
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var c = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        el.style.transform = 'translateY(' + ((0.5 - c) * 112).toFixed(1) + 'px)';
        el.style.opacity = Math.max(0, Math.min(1, 1.2 - Math.abs(0.5 - c) * 2.6)).toFixed(3);
      });
    };
    window.addEventListener('scroll', function () { window.requestAnimationFrame(scrollTick); }, { passive: true });
    window.addEventListener('resize', scrollTick);
    scrollTick();
  }

  /* ---------- Product gallery + full-screen viewer ---------- */
  var gallery = $('[data-gallery]');
  var viewer = $('#LbdViewer');
  var vImg = viewer && $('img', viewer);
  var vCounter = viewer && $('[data-viewer-counter]', viewer);
  var images = [], gi = 0;
  if (gallery) {
    var mainImg = $('[data-gallery-main]', gallery);
    var thumbs = $$('[data-thumb]', gallery);
    images = thumbs.map(function (t) { return { src: t.getAttribute('data-full'), alt: t.getAttribute('data-alt') || '' }; });
    if (!images.length && mainImg) images = [{ src: mainImg.getAttribute('data-full') || mainImg.src, alt: mainImg.alt }];
    function setMain(n) {
      gi = (n + images.length) % images.length;
      if (mainImg) {
        // Update srcset too: browsers keep showing the srcset image if only src changes.
        mainImg.srcset = imgSrcset(images[gi].src, [540, 800, 1200]);
        mainImg.src = imgSize(images[gi].src, 1200);
        mainImg.alt = images[gi].alt;
      }
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === gi); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { setMain(k); }); });
    gallery.addEventListener('click', function (e) {
      if (e.target.closest('[data-gallery-open]')) openViewer(gi);
    });
  }
  function openViewer(n) {
    if (!viewer || !images.length) return;
    lastFocus = document.activeElement;
    viewer.classList.add('is-open');
    viewer.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    showViewer(n);
    var c = $('[data-viewer-close]', viewer);
    if (c) c.focus();
  }
  function showViewer(n) {
    gi = (n + images.length) % images.length;
    if (vImg) { vImg.src = imgSize(images[gi].src, 1800); vImg.alt = images[gi].alt; }
    if (vCounter) vCounter.textContent = String(gi + 1).padStart(2, '0') + ' / ' + String(images.length).padStart(2, '0');
  }
  function closeViewer() {
    if (!viewer || !viewer.classList.contains('is-open')) return;
    viewer.classList.remove('is-open');
    viewer.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  if (viewer) {
    viewer.addEventListener('click', function (e) {
      if (e.target.closest('[data-viewer-prev]')) showViewer(gi - 1);
      else if (e.target.closest('[data-viewer-next]')) showViewer(gi + 1);
      else if (e.target.closest('[data-viewer-close]') || e.target === viewer || e.target.classList.contains('lbd-viewer__stage')) closeViewer();
    });
    document.addEventListener('keydown', function (e) {
      if (!viewer.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') showViewer(gi - 1);
      if (e.key === 'ArrowRight') showViewer(gi + 1);
    });
    var vx = null;
    viewer.addEventListener('touchstart', function (e) { vx = e.changedTouches[0].clientX; }, { passive: true });
    viewer.addEventListener('touchend', function (e) {
      if (vx === null) return;
      var dx = e.changedTouches[0].clientX - vx;
      vx = null;
      if (Math.abs(dx) > 40) showViewer(dx < 0 ? gi + 1 : gi - 1);
    }, { passive: true });
  }

  /* ---------- Filters toggle (mobile) ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-filters-toggle]');
    if (!t) return;
    var f = $('.lbd-filters');
    if (!f) return;
    var on = f.classList.toggle('is-open');
    t.setAttribute('aria-expanded', on ? 'true' : 'false');
    var lbl = t.querySelector('[data-filters-label]');
    if (lbl) lbl.textContent = on ? (t.getAttribute('data-hide') || lbl.textContent) : (t.getAttribute('data-show') || lbl.textContent);
  });
  document.addEventListener('input', function (e) {
    var r = e.target.closest('[data-price-range]');
    if (!r) return;
    var out = document.querySelector('[data-price-label]');
    if (out) out.textContent = r.value;
  });

  /* ---------- Filter inputs submit on change ---------- */
  document.addEventListener('change', function (e) {
    var el = e.target.closest('[data-auto-submit]');
    if (el && el.form) el.form.submit();
  });

  /* ---------- Contact prefill from ?piece= & ?subject= ---------- */
  var contact = $('[data-contact-form]');
  if (contact) {
    var params = new URLSearchParams(window.location.search);
    var pieceSel = $('[data-piece-select]', contact);
    var subjSel = $('[data-subject-select]', contact);
    function pick(sel, key) {
      if (!sel || !key) return;
      var opt = sel.querySelector('option[data-key="' + key.replace(/"/g, '') + '"]');
      if (opt) sel.value = opt.value;
    }
    pick(pieceSel, params.get('piece'));
    pick(subjSel, params.get('subject'));
  }
})();
